import React from 'react';

interface GVTabPanelProps {
  index: number;
  children: React.ReactElement | Array<React.ReactElement>;
  value: number;
}

function GVTabPanel(props: GVTabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && props.children}
    </div>
  );
}
export default GVTabPanel;
